"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Bucket_1 = __importDefault(require("../ua/Bucket"));
// https://reference.opcfoundation.org/v104/Core/docs/Part6/7.1.2/#7.1.2.2
class ConnectionProtocolMessageHeader {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.MessageType = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.MessageType, (_b !== null && _b !== void 0 ? _b : ''));
        this.ChunkType = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ChunkType, (_d !== null && _d !== void 0 ? _d : ''));
        this.MessageSize = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.MessageSize, (_f !== null && _f !== void 0 ? _f : 0));
    }
    encode() {
        const bucket = new Bucket_1.default();
        bucket.writeStringBytes(this.MessageType);
        bucket.writeStringBytes(this.ChunkType);
        bucket.writeUint32(this.MessageSize);
        return bucket.bytes;
    }
    decode(b, position) {
        const bucket = new Bucket_1.default(b, position);
        this.MessageType = bucket.readStringBytes(3);
        this.ChunkType = bucket.readStringBytes(1);
        this.MessageSize = bucket.readUint32();
        return bucket.position;
    }
}
exports.default = ConnectionProtocolMessageHeader;
